import { AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { IonicModule, LoadingController } from '@ionic/angular';
import { ToastController } from '@ionic/angular';
import { Analysis, BeerProfileRequest, BeerStat, SearchCharacteristicWithType, SearchType, AnalysisItem, LocalCharacteristic, Venue, SimilarBeerRequest, BaseFlavors} from "../../models/models";
import { AnalysisServiceProvider } from '../../providers/analysis-service/analysis-service';
import { LocationServiceProvider } from "../../providers/location-service/location-service";
import { UserDataProvider } from '../../providers/user-data/user-data';
import { BeerServiceProvider } from '../../providers/beer-service/beer-service';
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { AnalysisHolderProvider } from '../../providers/analysis-holder/analysis-holder';
import { RefdataProvider } from '../../providers/refdata/refdata';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage-angular';
import { AppEventService } from '../../app/app-events';
import { SimilarBeersComponent } from '../similar-beers/similar-beers';
import { BeerSpiderComponent } from '../beer-spider/beer-spider';
import { BeerCcComponent } from '../beer-cc/beer-cc';
import { FlavorSliderAnalysisComponent } from '../flavor-slider/flavor-slider-analysis';
import { BeerHiveComponent } from '../beer-hive/beer-hive';
import { BeerIbaComponent } from '../beer-iba/beer-iba';
import { BeerAromasComponent } from '../beer-aromas/beer-aromas';
import { RatingBarComponent } from '../rating-bar/rating-bar';
import { WishlistButtonComponent } from '../wishlist-button/wishlist-button';
import { CommonModule } from '@angular/common';
import { MyNotesComponent } from '../my-notes/my-notes';
import { FormsModule } from '@angular/forms';
import { BeerAnalysisMyComponent } from './beer-analysis-my';

/**
 * Generated class for the BeerAnalysisMyComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'beer-analysis-my-ratingnotes',
  templateUrl: 'beer-analysis-my-ratingnotes.html',
  styleUrls: ['./beer-analysis-my.scss'],
  standalone: false,
  imports: [
    IonicModule,
    TranslateModule,
    SimilarBeersComponent,
    BeerSpiderComponent,
    BeerCcComponent,
    FlavorSliderAnalysisComponent,
    BeerHiveComponent,
    BeerIbaComponent,
    BeerAromasComponent,
    RatingBarComponent,
    WishlistButtonComponent,
    CommonModule,
    FormsModule,
    MyNotesComponent
  ]
})

export class BeerAnalysisMyRatingNotesComponent extends BeerAnalysisMyComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {

  ignoreTotalExperienceValue: boolean;

  /*
   *  transport objects to convey data from and to the gui
   */
  totalexperience: number;
  totalexperienceGUIValue: number;
  notes: string;

  /*
   *  the model: beerID and analysis objects
   */
  theBeerID: string;

  /*
   *  other local attributes
   */
  // contains nbr of analyses per group (currently always 1 for group "brewer" and >=1 for group "beerhive")
  @Input()
  set beerID(bID: string) {
    this.theBeerID = bID;
    this.updateBeerID(bID);
  }
  get beerID() {
    return this.theBeerID;
  }

  private showBeerSubscription: any;
  private analysisTotalexperienceSubscription: any;
  private updateNotesSubscription: any;

  constructor(
    protected toastController: ToastController,
    protected events: AppEventService,
    protected analysisService: AnalysisServiceProvider,
    private locationService: LocationServiceProvider,
    private userData: UserDataProvider,
    private beerService: BeerServiceProvider,
    protected bhutil: BhutilProvider,
    private loadingCtrl: LoadingController,
    protected beerAnalysisHolder: AnalysisHolderProvider,
    private refdata: RefdataProvider,
    protected translateService: TranslateService,
    private storage: Storage
  ) {
    super(toastController, events, analysisService, bhutil, beerAnalysisHolder, translateService);

    this.ignoreTotalExperienceValue = false;

    //analysis info
    this.totalexperience = null;
    this.totalexperienceGUIValue = null;

    this.updateNotesSubscription = (updatedNotes: string) => {
      console.log("[beer-analysis-my-ratingnotes] SUB update:notes");
      this.updateNotesTransferObjectAndModel(updatedNotes);
    };

    this.analysisTotalexperienceSubscription = (newTotalExperience: number) => {
      //debugger;
      if (this.ignoreTotalExperienceValue) {
        console.log("[beer-analysis-my-ratingnotes] ignoring this totalexperience update");
        this.ignoreTotalExperienceValue = false;
      } else {
        this.updateTotalExperienceModelFromGUI(newTotalExperience);
      }
    };

    this.showBeerSubscription = () => {
      console.log("[beer-analysis-my.showBeerSubscription] called");
      // needed???
      this.clearTransferObjectsAndModel();

      // 2 Fill the model
      // 2A if the beer profile is not yet loaded, load the beer profile
      // 2B if the beer profile is already loaded, switch the analysisHolder to the beer
      if (this.beerAnalysisHolder.hasActiveBeer()) {
        this.updateBeerID(this.beerAnalysisHolder.getActiveBeer());

        if (this.beerAnalysisHolder.hasBeer(this.theBeerID)) {
          console.log("Beeranalysiscomponent.showBeerSubscription: switch to beer " + this.theBeerID);
          this.beerAnalysisHolder.switchToBeer(this.theBeerID);

          // 3 Update the GUI elements, fill the transfer objects and publish the updates to the GUI
          this.updateView();
        }
        else {
          console.log("BeeranalysisMyComponent.showBeerSubscription: no beer profile");
        }
      }
      else {
          console.log("BeeranalysisMyComponent.showBeerSubscription: no active beer");
      }
    };
  }
  private clearTransferObjectsAndModel() {
    // 1 Make the context clean:
    //   - empty the model: deactivate the previous beer profile from the analysis holder
    //   - empty the transfer objects and the view
    // 2 Fill the model
    // 2A if the beer profile is not yet loaded, load the beer profile
    // 2B if the beer profile is already loaded, switch the analysisHolder to the beer
    //
    // 3 Fill the transfer objects and publish the updates to the GUI
    // 1 Make the context clean:

    //   - empty the transfer objects and the view
    //total experience
    this.clearTotalExperienceTransferObjectAndPublishEvent();
    //notes
    this.updateNotesTransferObjectAndModel("");

    // inform beer-hive component
    this.events.publish("clear:analysis", true);
  }

  ionViewWillEnter() {
    console.log("beer-analysis-my - ionViewWillEnter called");
    if (this.refdata.isAndroid()) {
      console.log('setting fixed position dynamically for android');
      let saveButtonEl: HTMLElement = document.getElementById('save');
      saveButtonEl.style.position = 'fixed';
      // critcontainerEl.style.zIndex = '100';
    }
  }

  ngAfterViewInit() {
    console.log("[beer-analysis-my-ratingnotes] ngAfterViewInit called");
    this.showCurrentAnalysis(false);
    /*this.storage.get('selected-venue').then((venue) => {
      // First read the selected venue from storage
      let venueJSON = JSON.parse(venue);
      if (venueJSON != null) {
        this.selectedVenue = venueJSON;
        console.log("[my-analyses] - currently venue with id selected: " + venueJSON.id);
      }
    });*/
  }

  updateNotesTransferObjectAndModel(updatedNotes: string) {
    console.log("[beer-analysis-my-ratingnotes] - new notes: " + updatedNotes);

    // Guard against unnecessary updates
    if (this.notes != updatedNotes) {
      // update the transfer object
      this.notes = updatedNotes;
      //debugger;

      // update the model
      this.beerAnalysisHolder.getMyAnalysis().notes = updatedNotes;
      this.beerAnalysisHolder.checkForDifferences();
    }

  }

  private updateTotalExperienceTransferObjects(updatedTotalExperience: number) {
      this.totalexperience = updatedTotalExperience;
      if (updatedTotalExperience > 0)
        this.totalexperienceGUIValue = this.getRounded(2 * this.totalexperience);
      else
        this.totalexperienceGUIValue = 0;
  }
  updateTotalExperienceModelFromGUI(updatedTotalExperience: number) {
    console.log("[beer-analysis-my-ratingnotes] - updateTotalExperience(), new value: " + updatedTotalExperience);

    // update the transfer object if it changed
    if (this.totalexperience != updatedTotalExperience) {
      this.updateTotalExperienceTransferObjects(updatedTotalExperience);

      // update the model
      this.beerAnalysisHolder.getMyAnalysis().totalexperience = updatedTotalExperience / 2.0;
      this.beerAnalysisHolder.checkForDifferences();
    }
  }

  // show current analysis instance
  showCurrentAnalysis(shouldShowToast: boolean) {
    console.log("[beer-analysis-my.showCurrentAnalysis] called with shouldShowToast = " + shouldShowToast);

    let currentAnalysis: Analysis = this.beerAnalysisHolder.getMyAnalysis();
    // this.tweakAnalysisBeforeViewing(currentAnalysis);

    // Step 1: populate transfer objects
    this.updateTotalExperienceFromAnalysis(currentAnalysis);
    this.updateNotesFromAnalysis(currentAnalysis);

    let currentAnalysisId = currentAnalysis.id;
    if (currentAnalysisId != undefined)
      this.analysisService.setAnalysisId(currentAnalysisId);
  }

  updateBeerID(bID: string) {
    console.log("updateBeerID() => " + bID);
    //debugger;
    this.theBeerID = bID;
    this.analysisService.setBeerId(bID);
  }

  ngOnInit() {
    console.log("[beer-analysis-my-ratingnotes] [ngOnInit] called");
    // setting last caller page
    this.events.subscribe("update:notes", this.updateNotesSubscription);
    this.events.subscribe("analysis:totalexperience", this.analysisTotalexperienceSubscription);
    this.events.subscribe("beer-analysis:show:beer-analysis-my", this.showBeerSubscription);

    this.analysisService.setLastPage("analysis");
  }
  ngOnChanges() {
    console.log("[beer-analysis-my-ratingnotes] [ngOnChanges] called");
  }

  ngOnDestroy() {

    console.log("[beer-analysis-my-ratingnotes] [ngOnDestroy] DESTROYING for beer ID " + this.theBeerID);
    this.events.unsubscribe("beer-analysis:show:beer-analysis-my");
    this.events.unsubscribe("similar-beers:show:beer-analysis", this.showBeerSubscription);
    this.events.unsubscribe("analysis:totalexperience", this.analysisTotalexperienceSubscription);
    this.events.unsubscribe("update:notes", this.updateNotesSubscription);
  }

  public updateView() {
    console.log("[beer-analysis-my-ratingnotes] updateView() called");
    this.showCurrentAnalysis(false);
  }

  updateNotesFromAnalysis(currentAnalysis) {
    let currentNotes = currentAnalysis.notes;
    this.notes = currentNotes;
    this.events.publish("set:notes", currentNotes);
  }
  updateTotalExperienceFromAnalysis(currentAnalysis) {
    console.log("[beer-analysis-my-ratingnotes] updateTotalExperienceFromAnalysis()=> " + this.bhutil.stringify(currentAnalysis));

    this.updateTotalExperienceTransferObjects(currentAnalysis.totalexperience);

    let totalExperienceEvent = {
      "totalexperience": this.totalexperienceGUIValue
    }

    //this.ignoreTotalExperienceValue = true;//otherwise, the response will lead to another call!
    this.events.publish("beer-analysis-my-ratingnotes:update:totalexperience", totalExperienceEvent);
    //event will be received by "rating-bar" component(s)
  }

  clearTotalExperienceTransferObjectAndPublishEvent() {

    console.log("[beer-analysis-my-ratingnotes] clearTotalExperience()");

    this.updateTotalExperienceTransferObjects(0);

    let totalExperienceEvent = {
      "totalexperience": this.totalexperienceGUIValue
    }
    console.log("[beer-analysis-my-ratingnotes] - PUB clear:totalexperience; setting value to 0");
    this.events.publish("clear:totalexperience", totalExperienceEvent);
    //event will be received by "rating-bar" component(s)
  }
}
